<template>
  <div class='coursework-viewer__slide'>
    <pre class='coursework-viewer__text-container js-text-container' ref='textEl'></pre>
  </div>
</template>

<script>
  export default {
    props: {
      media: Object
    },
    methods: {
      init() {
        const request = new Kadenze.AjaxRequest({
          type: 'GET',
          data: null,
          dataType: 'text',
          dataAsJSON: false,
          url: this.media.file.url
        });

        request.done((response) => {
          $(this.$refs['textEl']).text(response);
          setTimeout(() => {
            this.$emit('ready', this.media.id)
          }, 100);
        });
      }
    },
    created() {
      this.$parent.slides.push(this);
    },
    mounted() {
      this.init();
    }
  }
</script>